import { Box, Typography } from "@mui/material";
import { clinicalStatus, financialStatus } from "./common";
import { dateFormater } from "../../../bmr/utils/common/utils";

const ToolTipContent = ({ data }) => {

    return <div className=" mx-auto rounded-2xl border">
        <div className="p-3" style={{
            backgroundColor: financialStatus[1]?.bgColor,
            borderTopRightRadius: '0.75rem',
            borderTopLeftRadius: '0.75rem',
        }}>
            <Typography variant="subtitle2" sx={{ color: financialStatus[1]?.text, fontWeight: 'bold' }}>
                Feasibility
            </Typography>
        </div>
        <div className="flex gap-4">
            <Box className=" !w-[96rem] ">
                <div className="p-3 flex flex-col gap-3">
                    <Typography variant="body1" className="flex gap-2">
                        <span className="text-[#808080]">Clinical Feasibility  </span>
                        <span>
                            {clinicalStatus[data?.clinical_status]?.lable ?? "--"}
                        </span>
                    </Typography>
                    <Typography variant="body1" className="flex gap-2">
                        <span className="text-[#808080]">Date  </span>{" "}
                        <span>
                            {data?.updated_at ? dateFormater(data.updated_at) : "--"}
                        </span>
                    </Typography>
                    <Typography variant="body1" className="flex gap-2">
                        <span className="text-[#808080]">Approved By  </span>{" "}
                        <span>
                            {data?.clinical_by?.name || "--"}
                        </span>
                    </Typography>
                    <Typography variant="body1" className="flex flex-col">
                        <span className="text-[#808080]">Comment </span>
                        <span>{data?.clinical_feasibility_comment || "--"}</span>
                    </Typography>
                </div>
            </Box>
        </div>
    </div>

}

export default ToolTipContent;